import { useContext } from 'react';
import { Box, Link, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import reviewContext from 'src/store/review-page-context';
import SubFillingDetailsSections from 'src/components/section/SubFillingDetailsSections=';
import { colors } from 'src/styles/theme';

const ReviewSection = () => {
  const { reviewInfo, exemptionModal } = useContext(reviewContext);
  const { review } = reviewInfo;
  const { exemptionModalController } = exemptionModal;

  const { eligibleForExemption } = review;

  return (
    <Box>
      {eligibleForExemption && (
        <>
          <Alert
            severity={review.updatedInfo.reqExempt === 'Y' ? 'info' : 'warning'}
            sx={
              review.updatedInfo.reqExempt === 'Y'
                ? {
                    backgroundColor: colors.dropzone.background,
                    border: `1px solid ${colors.primary.light}`,
                    color: colors.primary.dark,
                  }
                : {
                    backgroundColor: colors.alert.background,
                    border: `1px solid ${colors.alert.border}`,
                    color: colors.warning.brownTitle,
                  }
            }
          >
            {review.updatedInfo.reqExempt === 'Y'
              ? 'You have filled out the prerequisites for exemption. '
              : 'You may be eligible for exemption. '}
            <Link href="#" onClick={exemptionModalController.openModal}>
              <Typography variant="span" style={{ fontWeight: 'bold' }}>
                {review.updatedInfo.reqExempt === 'Y' ? 'Edit response' : 'Request Tax Exemption'}
              </Typography>
            </Link>
          </Alert>
        </>
      )}

      <SubFillingDetailsSections {...review} />
    </Box>
  );
};
export default ReviewSection;
